/**
 * Einstellungen im Browser liegen unter `dispositio.…`. Aus der Zeit vor der Umbenennung (SmartPlanning) stammen Schlüssel unter
 * `smartplanning.…` bzw. `sp.line`: sie werden einmal übernommen, wenn es den neuen Schlüssel noch nicht gibt, und dann entfernt.
 */
const LEGACY: [prefix: string, to: string][] = [
  ['smartplanning.', 'dispositio.'],
  ['sp.line', 'dispositio.line'],
];
/** Nicht mehr gebrauchte Schlüssel: eingeklappte Seitenleisten (sie starten jetzt immer ausgeklappt). */
const OBSOLETE = ['dispositio.rail.'];
const obsolete = (key: string): boolean => OBSOLETE.some((p) => key.startsWith(p));

export function migrateStoredSettings(store: Storage | null = safeStorage()): void {
  if (!store) return;
  const keys: string[] = [];
  for (let i = 0; i < store.length; i++) {
    const k = store.key(i);
    if (k) keys.push(k);
  }
  for (const key of keys) {
    if (obsolete(key)) {
      store.removeItem(key);
      continue;
    }
    const rule = LEGACY.find(([prefix]) => key.startsWith(prefix));
    if (!rule) continue;
    const target = rule[1] + key.slice(rule[0].length);
    const value = store.getItem(key);
    if (value !== null && store.getItem(target) === null && !obsolete(target)) store.setItem(target, value);
    store.removeItem(key);
  }
}

function safeStorage(): Storage | null {
  try {
    return window.localStorage;
  } catch {
    return null; // ohne Speicher (privates Fenster)
  }
}
